import React from 'react';
import { Alert } from '../Alert';
import { Icon } from '../Icon';

export const FormWrapper = ({ initialized, form, errors, errorTitle }) =>
  initialized ? (
    form
  ) : !errors.isEmpty() ? (
    <Alert color="danger" icon="alert-triangle">
      <p className="h4">{errorTitle || 'Failed to load'}</p>
      {errors
        .map((error, key) => (
          <p key={key} className="small mb-1">
            {error?.message || error}
          </p>
        ))
        .toList()}
    </Alert>
  ) : (
    <div className="d-flex justify-content-center p-4">
      <Icon name="loader" spin lg className="text-muted" />
    </div>
  );
